module.exports = __webpack_public_path__ + "img/cameroon.1c57fccc.png";